import "./src/styles/global.css";

const gtmId = process.env.GATSBY_GTM_ID;

export const onRouteUpdate = ({ location }) => {
  if (
    typeof window !== "undefined" &&
    location.pathname === "/" &&
    /#(invite|recovery)_token=/.test(location.hash)
  ) {
    window.location.replace(`/admin/${location.hash}`);
    return;
  }

  if (!gtmId || !window.dataLayer) {
    return;
  }

  window.dataLayer.push({
    event: "pageview",
    page_path: location.pathname,
  });
};
